import RcInstanceDTO, {
  ActivityTemplate,
} from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { WithWorkspaceId } from '~/types/common';
import { dashboardActivityTemplateApi, dashboardApi } from '~/utils/api';

export const getActivityTemplates = async ({ workspaceId }: WithWorkspaceId) =>
  dashboardActivityTemplateApi.get<ActivityTemplate[]>(
    `/workspaces/${workspaceId}/activity-templates`,
  );

type GitAppAttachedPackage = {
  name: string;
  repository: string;
  type: 'github-application-git' | 'gitlab-application-git';
  installationId: string | number;
  mode: 'attached';
  branch: string;
  automaticDeployEnabled: boolean;
};

type GitAppDetachedPackage = {
  name: string;
  repository: string;
  type: 'github-application-git' | 'gitlab-application-git';
  installationId: string | number;
  mode: 'detached';
  gitRef: string;
};

type GitAppPackage = GitAppAttachedPackage | GitAppDetachedPackage;

type GitPackage = {
  name: string;
  repository: string;
  type: 'public-git';
};

export type GitTaskPackageData = GitAppPackage | GitPackage;

export const getActivityTemplateById = async ({
  workspaceId,
  id,
}: { id: string } & WithWorkspaceId) =>
  dashboardActivityTemplateApi.get<ActivityTemplate>(
    `/workspaces/${workspaceId}/activity-templates/${id}`,
  );

export const deleteActivityTemplateById = async ({
  workspaceId,
  id,
}: { id: string } & WithWorkspaceId) =>
  dashboardActivityTemplateApi.delete<ActivityTemplate>(
    `/workspaces/${workspaceId}/activity-templates/${id}`,
  );

export const editActivityTemplate = async ({
  workspaceId,
  template,
}: { template: ActivityTemplate } & WithWorkspaceId) =>
  dashboardActivityTemplateApi.put<ActivityTemplate>(
    `/workspaces/${workspaceId}/activity-templates/${template.id}`,
    {
      ...template,
    },
  );

export const createActivityTemplate = async ({
  workspaceId,
  name,
}: { name: string } & WithWorkspaceId) =>
  dashboardActivityTemplateApi.post<ActivityTemplate>(
    `/workspaces/${workspaceId}/activity-templates`,
    {
      name,
    },
  );

export const getPackageDownloadLink = async ({
  workspaceId,
  id,
}: { id: string } & WithWorkspaceId) =>
  dashboardActivityTemplateApi.get<string>(
    `/workspaces/${workspaceId}/activity-templates/${id}/package/link`,
  );

export const getPackageUploadInfo = async ({ workspaceId, id }: { id: string } & WithWorkspaceId) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dashboardActivityTemplateApi.post<any>(
    `/workspaces/${workspaceId}/activity-templates/${id}/package`,
  );

export const handleGitRobot = async ({
  workspaceId,
  id,
  url,
}: { id: string; url: string } & WithWorkspaceId) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dashboardActivityTemplateApi.post<any>(
    `/workspaces/${workspaceId}/activity-templates/${id}/git-package`,
    {
      url,
    },
  );

export const createTaskPackage = async ({
  workspaceId,
  ...data
}: GitTaskPackageData & WithWorkspaceId) =>
  dashboardApi.post<RcInstanceDTO.ActivityTemplate>(
    `/workspaces/${workspaceId}/task-packages`,
    data,
  );

export const editTaskPackage = async (
  { id, workspaceId }: { id: string } & WithWorkspaceId,
  data: GitTaskPackageData,
) =>
  dashboardApi.put<RcInstanceDTO.ActivityTemplate>(
    `/workspaces/${workspaceId}/task-packages/${id}`,
    data,
  );

export const deleteTaskPackage = async ({ id, workspaceId }: { id: string } & WithWorkspaceId) =>
  dashboardApi.delete<RcInstanceDTO.ActivityTemplate>(
    `/workspaces/${workspaceId}/task-packages/${id}`,
  );
